import { notification } from 'antd';

const openNotification = ({type, message, description}) => {
  notification[type]({
    message: message,
    description:description,
    placement: 'bottomRight',
    duration: 10
  });
};
export default openNotification;


// WEBPACK FOOTER //
// src/components/Notification/Notificaiton.js